import { cacheGet, cacheSet } from './cache';

const B = 'https://api.themoviedb.org/3';
const TTL_SHOWS   = 24 * 60 * 60 * 1000;    // 24 hours
const TTL_DETAILS =  7 * 24 * 60 * 60 * 1000; // 7 days

export async function fetchEgyptianContent(key, year, d) {
  if (!d) return {shows:[]};
  const cacheKey = `tmdb_shows_${year}`;
  const cached = cacheGet(cacheKey);
  if (cached !== null) return cached;

  const p = s => s.poster_path ? `https://image.tmdb.org/t/p/w300${s.poster_path}` : null;
  const [res, genreRes] = await Promise.all([
    fetch(`${B}/discover/tv?api_key=${key}&with_origin_country=EG&first_air_date.gte=${d.start}&first_air_date.lte=${d.end}&sort_by=popularity.desc&language=ar`),
    fetch(`${B}/genre/tv/list?api_key=${key}&language=ar`),
  ]);
  const [td, gd] = await Promise.all([res.json(), genreRes.json()]);
  const genreMap = Object.fromEntries((gd.genres||[]).map(g=>[g.id, g.name]));
  const tv = s=>({id:s.id,mediaType:'tv',title:s.name,titleEn:s.original_name!==s.name?s.original_name:"",genre:(s.genre_ids||[]).map(id=>genreMap[id]).filter(Boolean).join(', ')||null,description:s.overview||"",poster:p(s),rating:s.vote_average?s.vote_average.toFixed(1):null,votes:s.vote_count,fromApi:true});
  const result = {shows:(td.results||[]).map(tv)};
  cacheSet(cacheKey, result, TTL_SHOWS);
  return result;
}

export async function searchTvShow(key, title) {
  const cacheKey = `tmdb_search_${title}`;
  const cached = cacheGet(cacheKey);
  if (cached !== null) return cached;

  const res = await fetch(`${B}/search/tv?api_key=${key}&query=${encodeURIComponent(title)}`);
  const data = await res.json();
  const result = (data.results || [])[0] || null;
  cacheSet(cacheKey, result, TTL_DETAILS);
  return result;
}

export async function fetchItemDetails(key, id, mediaType) {
  const cacheKey = `tmdb_details_${mediaType}_${id}`;
  const cached = cacheGet(cacheKey);
  if (cached !== null) return cached;

  const [detailsRes, videosRes] = await Promise.all([
    fetch(`${B}/${mediaType}/${id}?api_key=${key}&language=ar&append_to_response=credits`),
    fetch(`${B}/${mediaType}/${id}/videos?api_key=${key}`),
  ]);
  if (!detailsRes.ok) throw new Error('Not found');
  const [details, videos] = await Promise.all([detailsRes.json(), videosRes.json()]);
  const trailer = (videos.results||[]).find(v=>v.type==='Trailer'&&v.site==='YouTube')
    || (videos.results||[]).find(v=>v.site==='YouTube')
    || null;
  const result = {details, trailer};
  cacheSet(cacheKey, result, TTL_DETAILS);
  return result;
}
